module.exports = __webpack_public_path__ + "static/media/removeBtn.b8a758d3.png";